import { render, staticRenderFns } from "./QADetailModal.vue?vue&type=template&id=656f85e5"
import script from "./QADetailModal.vue?vue&type=script&lang=js"
export * from "./QADetailModal.vue?vue&type=script&lang=js"
import style0 from "./QADetailModal.vue?vue&type=style&index=0&id=656f85e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports